import React from 'react';

const UserIcon = ({ className, fill }) => (
  <svg width="8.664" height="10.288" viewBox="0 0 8.664 10.288" className={className}>
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_174" data-name="Rectangle 174" width="8.664" height="10.288" fill={fill || "#003965"}/>
      </clipPath>
    </defs>
    <g id="Group_619" data-name="Group 619" transform="translate(0 0)">
      <g id="user" transform="translate(0 0)" clip-path="url(#clip-path)">
        <path id="Path_1139" data-name="Path 1139" d="M6.057,6.323h0a3.092,3.092,0,0,1,.311.044A2.8,2.8,0,0,1,6.9,6.53,2.879,2.879,0,0,1,8.666,9.168v.723a.4.4,0,0,1-.4.4H.4a.4.4,0,0,1-.4-.4V9.168A2.87,2.87,0,0,1,1.765,6.53a2.912,2.912,0,0,1,.844-.206,3.4,3.4,0,1,1,3.447,0M4.333.79h0" transform="translate(0 -0.001)" fill={fill || "#003965"}/>
      </g>
    </g>
  </svg>
);

export default UserIcon; 